import React from 'react';
import { Modal, ModalWithTrigger } from '../modal';
import { Button } from '../../actions/button/button';
import { InfoIcon } from '../../../icons/info-icon';
import { useTranslation } from 'react-i18next';

interface HowDoBookingFeesWorkProps {
	withLabel?: boolean;
}

export const HowDoBookingFeesWork = ({ withLabel }: HowDoBookingFeesWorkProps) => {
	const { t } = useTranslation();
	return (
		<ModalWithTrigger
			trigger={
				<Button startIcon={<InfoIcon />} variant='link' fullWidth={withLabel ? true : false}>
					{withLabel ? t('checkout.modals.table_selection_fee.button_label') : null}
				</Button>
			}
		>
			<Modal.Header>{t('checkout.modals.table_selection_fee.title')}</Modal.Header>
			<Modal.Body>
				<p>
					{t('checkout.modals.table_selection_fee.description1')}
				</p>
				<p>
					{t('checkout.modals.table_selection_fee.description2')}
				</p>
			</Modal.Body>
			<Modal.Footer>
				<Modal.Close>
					<Button variant='tertiary' fullWidth>
						{t('checkout.modals.table_selection_fee.dismiss')}
					</Button>
				</Modal.Close>
			</Modal.Footer>
		</ModalWithTrigger>
	);
};
